import { css, keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import Icon from './Icon';

const beat = keyframes`
  from, 20%, 40%, to {
    width: 90%;
  }
  10%, 30% {
    width: 100%;
  }
`;

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
`;

const LoaderContainer = styled.div`
  width: 70px;
  height: 70vh;
  padding: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Loader = () => (
  <Wrapper data-testid="loader">
    <LoaderContainer>
      <Icon
        name="milkywire-symbol"
        css={css`
          width: 100%;
          height: 100%;
          animation: ${beat} 1s linear infinite;
        `}
      />
    </LoaderContainer>
  </Wrapper>
);

export default Loader;
